var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxsReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6673 16.6665L29.1673 4.1665H12.5007C11.3956 4.1665 10.3358 4.60549 9.55437 5.38689C8.77297 6.16829 8.33398 7.2281 8.33398 8.33317V41.6665C8.33398 42.7716 8.77297 43.8314 9.55437 44.6128C10.3358 45.3942 11.3956 45.8332 12.5007 45.8332H37.5007C38.6057 45.8332 39.6655 45.3942 40.4469 44.6128C41.2283 43.8314 41.6673 42.7716 41.6673 41.6665V16.6665ZM18.7507 39.5832H14.584V20.8332H18.7507V39.5832ZM27.084 39.5832H22.9173V27.0832H27.084V39.5832ZM35.4173 39.5832H31.2507V33.3332H35.4173V39.5832ZM29.1673 18.7498H27.084V8.33317L37.5007 18.7498H29.1673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsReport);
export default __webpack_public_path__ + "static/media/bxs_report.0c92c64de27429439c2a6eb6840e36ce.svg";
export { ForwardRef as ReactComponent };